import { ColumnType } from 'antd/es/table'
import { COLUMNS_IDS } from 'UI/VerticalTable/utils'
import columns from 'UI/VerticalTable/columns'

export const businessesColumns: ColumnType<any>[] = [
  columns[COLUMNS_IDS.businessName],
  columns[COLUMNS_IDS.businessReportedStatus],
  columns[COLUMNS_IDS.businessStructure],
  columns[COLUMNS_IDS.businessDataSources],
  columns[COLUMNS_IDS.businessIndustry],
  columns[COLUMNS_IDS.businessAddress],
  columns[COLUMNS_IDS.businessOwners],
  columns[COLUMNS_IDS.businessTin],
  columns[COLUMNS_IDS.businessLocations],
  columns[COLUMNS_IDS.businessEmployees],
  columns[COLUMNS_IDS.businessMarketingEfforts],
  columns[COLUMNS_IDS.businessDocumentedIncome],
  columns[COLUMNS_IDS.businessReportedIncome],
  columns[COLUMNS_IDS.businessNumberOfVisitors],
  columns[COLUMNS_IDS.businessNumberOfReviews],
  columns[COLUMNS_IDS.businessUntaxedIncome],
]
